import { Component, OnInit, ViewChild, Input } from '@angular/core';
import {
  NavController,
  AlertController,
  MenuController,
  ToastController,
  PopoverController,
  ModalController,

  Platform, LoadingController,

  IonSlides
} from '@ionic/angular';

import { GooglemapsComponent } from './../../components/googlemaps/googlemaps.component';
import { MarketIcon } from '../../interfaces/marketicon';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-map',
  templateUrl: './map.page.html',
  styleUrls: ['./map.page.scss'],
})
export class MapPage implements OnInit {

  yourLocation = '123 Test Street';
  themeCover = 'assets/img/ionic4-Start-Theme-cover.jpg';
  loading: any;

  @ViewChild(GooglemapsComponent) mapComponent: GooglemapsComponent;
  @ViewChild(IonSlides) slides: IonSlides;
  @Input() ads_markers: MarketIcon[];

  markers: MarketIcon[] = [];
  /* ads_markers: MarketIcon[] = [
    {
      lat: 42.345292,
      lng: -3.653008,
      title: 'Mi casa',
      icon: 1,
      animation: 1,
      image: 'https://lh5.googleusercontent.com/p/AF1QipOCgzq_0DYB9AxD-ItTG01x2csLsSfWsawBCypc=w408-h306-k-no',
      text: 'Animi voluptatem, aliquid impedit ratione placeat necessitatibus quisquam molestiae obcaecati laudantium?'
    },
    {
      lat: 42.350786,
      lng: -3.639876,
      title: 'Calle la Bureba',
      icon: 2,
      animation: 2,
      image: 'https://lh5.googleusercontent.com/p/AF1QipOCgzq_0DYB9AxD-ItTG01x2csLsSfWsawBCypc=w408-h306-k-no',
      text: 'Animi voluptatem, aliquid impedit ratione placeat necessitatibus quisquam molestiae obcaecati laudantium?'
    },
    {
      lat: 42.35677,
      lng: -3.656924,
      title: 'Calle Vitoria',
      icon: 2,
      animation: 2,
      image: 'https://lh5.googleusercontent.com/p/AF1QipOCgzq_0DYB9AxD-ItTG01x2csLsSfWsawBCypc=w408-h306-k-no',
      text: 'Animi voluptatem, aliquid impedit ratione placeat necessitatibus quisquam molestiae obcaecati laudantium?'
    },
    {
      lat: 42.359015,
      lng: -3.645702,
      title: 'Taglosa',
      icon: 2,
      animation: 2,
      image: 'https://lh5.googleusercontent.com/p/AF1QipOCgzq_0DYB9AxD-ItTG01x2csLsSfWsawBCypc=w408-h306-k-no',
      text: 'Animi voluptatem, aliquid impedit ratione placeat necessitatibus quisquam molestiae obcaecati laudantium?'
    },
  ]; */

  constructor(
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public menuCtrl: MenuController,
    public toastCtrl: ToastController,
    private router: Router,
    public translate: TranslateService
  ) { }

  ngOnInit() {
  }

  closeModal(){
    this.modalCtrl.dismiss();
  }

  ionViewDidEnter() {
    // Al ser una modal realizar la carga de los marcadores desde esta función porque si no da error al cargar los markers y los slides
    this.markers = this.ads_markers;
  }

  /**
   * Función que filtra los items que no nos interesan mostrar, como lo es el slider en mapas
   */
  processMarkets(){
    return this.markers.filter(x => x.lat != null);
   }

   async onSlideDidChange() {
     const currentSlide = await this.slides.getActiveIndex();
     console.log(currentSlide);
     this.mapComponent.onSlideDidChange(currentSlide);
   }

   testMarker(){
     console.log("testmarket ");
     console.log(this.markers);
      if(this.mapComponent.mapsLoaded && this.mapComponent.currentLocation != null) {

        let currentLocation = this.mapComponent.currentLocation;
        this.mapComponent.addMarker(currentLocation.coords.latitude,
            currentLocation.coords.longitude,
            google.maps.Animation.DROP,
            0,
            '',
            '',
            '',
            '',
            '',
            '',
            true);

        // Mover el puntero
        this.mapComponent.map.panTo({lat: currentLocation.coords.latitude, lng: currentLocation.coords.longitude});

      }
   }

   // Google maps

  ionViewWillEnter() {
    //this.menuCtrl.enable(true);
  }

  settings() {
    //this.navCtrl.navigateForward('settings');
  }

  async alertLocation() {
    const changeLocation = await this.alertCtrl.create({
      header: 'Change Location',
      message: 'Type your Address.',
      inputs: [
        {
          name: 'location',
          placeholder: 'Enter your new Location',
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Change',
          handler: async (data) => {
            console.log('Change clicked', data);
            this.yourLocation = data.location;
            const toast = await this.toastCtrl.create({
              message: 'Location was change successfully',
              duration: 3000,
              position: 'top',
              // closeButtonText: 'OK',
              // showCloseButton: true
            });

            toast.present();
          }
        }
      ]
    });
    changeLocation.present();
  }

  detalleProducto(relative_url){
    this.closeModal();
    this.navCtrl.navigateForward(relative_url);
  }

}
